import { useEffect } from "react"
import { useQuery } from "@apollo/client"
import { LikableTeamsList } from "@pallet/features/RecruitingTeamType/LikableTeamsList"
import { LikeTeamActionProvider } from "@pallet/features/RecruitingTeamType/LikeTeamAction/hooks"
import { TeamProfileModal } from "@pallet/features/RecruitingTeamType/TeamProfileModal"
import { TeamProfileModalProvider } from "@pallet/features/RecruitingTeamType/TeamProfileModal/hooks"
import { Box } from "@pallet-hq/hegel"
import { PageContainer } from "page-components/atoms/AppPages"
import { usePalletContext } from "utils/hooks/usePalletContext"
import { PALLET_PARTNERED_TEAMS_QUERY } from "./queries"
import { PalletPartneredTeamsQuery } from "__generated__/PalletPartneredTeamsQuery"
import mixpanel from "mixpanel-browser"
import { EVENTS } from "constants/events"

const PalletCompanies = () => {
    const { pallet } = usePalletContext()
    const { data, loading, fetchMore } = useQuery<PalletPartneredTeamsQuery>(
        PALLET_PARTNERED_TEAMS_QUERY,
        {
            variables: { first: 10, pallet: pallet },
            ssr: false,
        }
    )
    useEffect(() => {
        mixpanel.track(EVENTS.VIEW_COMPANIES, {
            pallet: pallet,
        })
    })

    return (
        <LikeTeamActionProvider pallet={pallet ?? undefined}>
            <TeamProfileModalProvider>
                <PageContainer>
                    <Box
                        display="flex"
                        flexDirection="column"
                        mx="auto"
                        px="xsmall"
                        width={["100vw", "816px"]}
                        style={{ boxSizing: "border-box" }}
                    >
                        <LikableTeamsList
                            teamConnection={data?.applylist?.partneredTeams}
                            loading={loading}
                            fetchMore={fetchMore}
                            showPosts={false}
                        />
                    </Box>
                </PageContainer>
                <TeamProfileModal />
            </TeamProfileModalProvider>
        </LikeTeamActionProvider>
    )
}

export { PalletCompanies }
